<template>
  <div class="flex flex-column gap-2">
    <h4 class="m-0">History</h4>

    <a-collapse v-model="activeKey">
      <a-collapse-panel :header="getTypeHeader">
        <div
          :style="{ overflow: 'auto', maxHeight: '200px' }"
          class="flex flex-column gap-2"
          v-if="getTotalDays.length"
        >
          <div class="flex gap-2" v-for="(day, idx) in getTotalDays" :key="idx">
            <span> {{ formatDateString(day.date) }}</span>
            <span :style="{ color: day.status === 'paid' ? '#10b981' : '#ef4444' }">{{
              day.status === 'paid' ? 'Paid' : 'Unpaid'
            }}</span>
          </div>
        </div>

        <span class="text-center w-full flex justify-content-center" v-else>
          No History Found for {{ type.title }}
        </span>
      </a-collapse-panel>
    </a-collapse>
  </div>
</template>

<script>
import { TIME_OFF_TYPE } from '@/store/modules/time-off/constant'
import { Collapse } from 'ant-design-vue'
import moment from 'moment-timezone'
import { createNamespacedHelpers } from 'vuex'
const { mapState } = createNamespacedHelpers('timeOff')

export default {
  components: {
    'a-collapse': Collapse,
    'a-collapse-panel': Collapse.Panel
  },
  data() {
    return {
      activeKey: []
    }
  },
  computed: {
    ...mapState({
      timeOff: state => state.timeOff
    }),

    type() {
      return TIME_OFF_TYPE[this.timeOff.type]
    },

    getTypeHeader() {
      const stat = this.timeOff.statistic

      if (!stat || stat.length === 0) {
        return `${this.type.title}: 0 days`
      }

      const paidCount = stat.filter(
        item => item.shift && item.shift.pay_code && item.shift.internal_payment_info.ready_for_pay_status !== 'blocked'
      ).length
      const unpaidCount = stat.length - paidCount

      const parts = [paidCount > 0 && `${paidCount} Paid`, unpaidCount > 0 && `${unpaidCount} Unpaid`].filter(Boolean)

      const statusStr = parts.length ? ' - ' + parts.join(' / ') : ''

      const dayLabel = stat.length === 1 ? 'day' : 'days'

      return `${this.type.title}: ${stat.length} ${dayLabel}${statusStr}`
    },

    timeZone() {
      return this.$store.state.applicationState.timeZone
    },

    getTotalDays() {
      return this.timeOff.statistic.map(item => ({
        date: item.date,
        status:
          item.shift && item.shift.pay_code && item.shift.internal_payment_info.ready_for_pay_status !== 'blocked'
            ? 'paid'
            : 'unpaid'
      }))
    }
  },
  methods: {
    formatDateString(date) {
      return moment.utc(date).tz(this.timeZone).format('MM/DD/YYYY')
    }
  }
}
</script>
